import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GET_STAFF_MANAGEMENT_WORKERS } from "graphql/query/staff-management-gql";
import { Tables } from "components/layout";
import StaffManagementConst from "components/staff-management/staff-management-const";
import StaffWorkersTableFilter from "components/staff-management/filters/staff-workers-table-filter";
import StaffManagementHooks from "components/staff-management/hooks";
import {
    getStaffWorkersQueryState,
    STAFF_WORKERS_PAGE_SIZE,
} from "components/staff-management/helpers/staff-workers-api-helper";
import StaffWorkersTableHelper from "components/staff-management/helpers/staff-workers-table-helper";


const WORKERS_ORDER_BY = [
    { column: "NAME", order: "ASC" },
    { column: "SURNAME", order: "ASC" },
    { column: "ID", order: "ASC" },
];

const StaffManagementWorkersSubPage = ({ event }) => {
    const history = useHistory();
    const routeUrl = `${ StaffManagementConst.basePath }/${ event.id }/workers`;
    const match = useRouteMatch(`${ routeUrl }/page/:pageNum`);
    const parsedPage = match ? Number(match.params.pageNum) : 1;
    const validRequestedPage = Number.isInteger(parsedPage) && parsedPage > 0;
    const canonicalPagePath = !match || (validRequestedPage && parsedPage > 1);
    const requestedPage = validRequestedPage ? parsedPage : 1;
    const [ searchText, setSearchText ] = useState("");
    const [ roleID, setRoleID ] = useState();
    const [ subcontractorID, setSubcontractorID ] = useState();
    const [ visibleWorkers, setVisibleWorkers ] = useState([]);
    const queryState = useMemo(() => getStaffWorkersQueryState({
        eventRoles: event.relWorkerRoles,
        selectedRoleID: roleID,
        subcontractorID,
    }), [ event.relWorkerRoles, roleID, subcontractorID ]);
    const { sessionSummaries } = StaffManagementHooks.useStaffWorkerSessions({
        eeID: event.id,
        workers: visibleWorkers,
    });

    const resetPage = useCallback(() => {
        if (requestedPage !== 1)
        {
            history.push(routeUrl);
        }
    }, [ history, requestedPage, routeUrl ]);

    useEffect(() => {
        if (!canonicalPagePath)
        {
            history.replace(routeUrl);
        }
    }, [ canonicalPagePath, history, routeUrl ]);

    useEffect(() => {
        if (roleID && !queryState.eligibleRoleIDs.includes(String(roleID)))
        {
            setRoleID(undefined);
            resetPage();
        }
    }, [ queryState.eligibleRoleIDs, resetPage, roleID ]);

    return (
        <div className="staff-management-view-shell--workers">
            <Tables.Main
                model="users"
                query={ GET_STAFF_MANAGEMENT_WORKERS }
                routeUrl={ routeUrl }
                currentPage={ requestedPage }
                searchText={ searchText }
                objFilter={ queryState.where }
                objOrderBy={ WORKERS_ORDER_BY }
                currentObj={ { sessionSummaries } }
                onData={ setVisibleWorkers }
                varSet={ {
                    perPage: STAFF_WORKERS_PAGE_SIZE,
                    eeID: [ String(event.id) ],
                } }
                tableHelper={ StaffWorkersTableHelper }
                extraClass="staff-workers-table"
                scroll={ { x: 1318 } }>
                <StaffWorkersTableFilter
                    eventRoles={ event.relWorkerRoles || [] }
                    searchText={ searchText }
                    setSearchText={ setSearchText }
                    roleID={ roleID }
                    setRoleID={ setRoleID }
                    subcontractorID={ subcontractorID }
                    setSubcontractorID={ setSubcontractorID }
                    resetPage={ resetPage } />
            </Tables.Main>
        </div>
    );
};

export default StaffManagementWorkersSubPage;
